import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { UserType } from '@shared-features/enums';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RolesConstants } from '@shared/constants';
import { LayoutService } from '@layout/services/layout.service';
import { PasswordValidator } from '@shared/utils';
import { BaseComponent } from '../base-component/base.component';
import { ModalComponent } from '@shared/components/modal/modal.component';
import { UserApi } from '../../services';
import { Router } from '@angular/router';
import { RoutesUtil } from '@shared-features/utils';
import { User } from '@features/users/models/user.model';
@Component({
  selector: 'app-view-edit-user',
  templateUrl: './view-edit-user.component.html',
  styleUrls: ['./view-edit-user.component.scss'],
})
export class ViewEditUserComponent extends BaseComponent implements OnChanges {
  @Input() userType: UserType;
  @Input() userId: string;
  @Input() parentId: string;
  @Input() allowEdit: boolean;
  @Input() isProfile: boolean;
  @Output() loadUser = new EventEmitter<User>();
  id: string;
  selectedUser: User = new User();
  viewMode = true;
  form: FormGroup;
  rolesConstants = RolesConstants;
  UserType = UserType;
  @ViewChild('passwordModal')
  passwordModal: ModalComponent;

  passwordForm: FormGroup;
  showPassword = false;
  showNewPassword = false;

  constructor(private router: Router, public layoutService: LayoutService, private userApiService: UserApi, private builder: FormBuilder) {
    super();
  }

  ngOnChanges({ userId, parentId }: SimpleChanges): void {
    if (userId && userId.currentValue !== userId.previousValue) {
      this.id = this.userId;
      this.getUser();
    }
    if (parentId && parentId.currentValue !== parentId.previousValue) {
      this.id = this.parentId;
      this.getUser();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.complete();
  }

  getUser() {
    this.load(this.userApiService.getUserById(this.id)).subscribe((user) => {
      this.selectedUser = user;
      this.initForm();
    });
  }
  onResetPassword() {
    this.passwordModal.showModal();
    this.resetPasswordForm();
  }

  resetPasswordForm() {
    this.passwordForm?.reset();
    this.passwordForm?.updateValueAndValidity();
  }

  onCancelUserButtonClicked() {
    this.viewMode = true;
  }

  handleUpdateEvent(event) {
    this.viewMode = true;
    this.selectedUser = event.user;
  }

  private initForm() {
    this.passwordForm = this.builder.group({
      password: ['', [Validators.required]],
      newPassword: ['', [Validators.required, PasswordValidator]],
    });
  }

  handleCancelPassword() {
    this.resetPasswordForm();
    this.passwordModal.closeModal();
  }

  updatePassword() {
    if (!this.isProfile || !this.passwordForm?.valid) {
      return;
    }
    this.load(
      this.userApiService.customResetPassword(
        this.parentId,
        this.userType,
        this.passwordForm?.value?.password,
        this.passwordForm?.value?.newPassword
      )
    ).subscribe((response) => {
      this.showSuccessMessage('SuccessMessages.PasswordChangedSuccessfully');
      this.router.navigate([RoutesUtil.AuthLogin.url()]);
    });
    this.passwordModal.closeModal();
  }
}
